// This is NOT a Lookup Enum. It is a custom enum for the typeName property of the processorType field.
export enum DocGenProcessorType {
  ReplaceDocProcessor = "ReplaceDocProcessor",
  RepeaterDocProcessor = "RepeaterDocProcessor",
}

/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum DocumentCategory {
    Application = "murn:smart:lookup/DocumentCategory/Application",
    Complaint = "murn:smart:lookup/DocumentCategory/Complaint",
    Inspection = "murn:smart:lookup/DocumentCategory/Inspection",
    Permit = "murn:smart:lookup/DocumentCategory/Permit",
    PermitVersion = "murn:smart:lookup/DocumentCategory/PermitVersion",
    SWMP = "murn:smart:lookup/DocumentCategory/SWMP",
    Report = "murn:smart:lookup/DocumentCategory/Report",
    FinancialAssurance = "murn:smart:lookup/DocumentCategory/FinancialAssurance",
  }

  export enum DocumentType {
    FinancialAssuranceDocument = "murn:smart:lookup/DocumentType/FinancialAssuranceDocument",
  }

  export enum Country {
    CAN = "murn:smart:lookup/Country/CAN",
    USA = "murn:smart:lookup/Country/USA",
  }

  export enum ApplicationStatus {
    Pending = "murn:smart:lookup/ApplicationStatus/Pending",
    Complete = "murn:smart:lookup/ApplicationStatus/Complete",
    Withdrawn = "murn:smart:lookup/ApplicationStatus/Withdrawn",
  }

  export enum ApplicationType {
    Initial = "murn:smart:lookup/ApplicationType/Initial",
    Modification = "murn:smart:lookup/ApplicationType/Modification",
    Renewal = "murn:smart:lookup/ApplicationType/Renewal",
  }

  export enum DisposalReportStatus {
    Draft = "murn:smart:lookup/DisposalReportStatus/Draft",
    PastDue = "murn:smart:lookup/DisposalReportStatus/PastDue",
    Scheduled = "murn:smart:lookup/DisposalReportStatus/Scheduled",
    Submitted = "murn:smart:lookup/DisposalReportStatus/Submitted",
    // Verified = "murn:smart:lookup/DisposalReportStatus/Verified",
    Approved = "murn:smart:lookup/DisposalReportStatus/Approved",
  }

  export enum EntityType {
    Custom = "murn:smart:lookup/EntityType/Custom",
  }

  export enum FacilitySiteType {
    ClassIIIWaiver = "murn:smart:lookup/FacilitySiteType/ClassIIIWaiver",
  }

  export enum InspectionStatus {
    Due = "murn:smart:lookup/InspectionStatus/Due",
    Completed = "murn:smart:lookup/InspectionStatus/Completed",
  }

  export enum PermitType {
    Class3 = "murn:smart:lookup/PermitType/Class3",
    Class3Waiver = "murn:smart:lookup/PermitType/Class3Waiver",
  }

  export enum PermitVersionStatus {
    Effective = "murn:smart:lookup/PermitVersionStatus/Effective",
    Expired = "murn:smart:lookup/PermitVersionStatus/Expired",
    Issued = "murn:smart:lookup/PermitVersionStatus/Issued",
    Modified = "murn:smart:lookup/PermitVersionStatus/Modified",
    Pending = "murn:smart:lookup/PermitVersionStatus/Pending",
    Renewed = "murn:smart:lookup/PermitVersionStatus/Renewed",
    Terminated = "murn:smart:lookup/PermitVersionStatus/Terminated",
  }

  export enum RecyclingReportStatus {
    Draft = "murn:smart:lookup/RecyclingReportStatus/Draft",
    Submitted = "murn:smart:lookup/RecyclingReportStatus/Submitted",
    Verified = "murn:smart:lookup/RecyclingReportStatus/Verified",
  }

  export enum ReportFrequencies {
    AsNeeded = "murn:smart:lookup/ReportFrequency/AsNeeded",
    Annual = "murn:smart:lookup/ReportFrequency/Annual",
    OneTime = "murn:smart:lookup/ReportFrequency/OneTime",
    SemiAnnual = "murn:smart:lookup/ReportFrequency/SemiAnnual",
    Quarter = "murn:smart:lookup/ReportFrequency/Quarter",
    Quinquennial = "murn:smart:lookup/ReportFrequency/Quinquennial",
  }

  export enum ReportStatus {
    Draft = "murn:smart:lookup/ReportStatus/Draft",
    Scheduled = "murn:smart:lookup/ReportStatus/Scheduled",
    Submitted = "murn:smart:lookup/ReportStatus/Submitted",
    // Verified = "murn:smart:lookup/ReportStatus/Verified",
    Approved = "murn:smart:lookup/ReportStatus/Approved",
    Waived = "murn:smart:lookup/ReportStatus/Waived",
  }

  export enum ReportType {
    AnnualReport = "murn:smart:lookup/ReportType/AnnualReport",
    CapacityReport = "murn:smart:lookup/ReportType/CapacityReport",
    ConstructionQualityAssuranceReport = "murn:smart:lookup/ReportType/ConstructionQualityAssuranceReport",
    DisposalReport = "murn:smart:lookup/ReportType/DisposalReport",
    FinancialAssuranceReport = "murn:smart:lookup/ReportType/FinancialAssuranceReport",
    GasMonitoringReport = "murn:smart:lookup/ReportType/GasMonitoringReport",
    GroundwaterMonitoringReport = "murn:smart:lookup/ReportType/GroundwaterMonitoringReport",
    LeachateCollectionReport = "murn:smart:lookup/ReportType/LeachateCollectionReport",
    MethaneMonitoringReport = "murn:smart:lookup/ReportType/MethaneMonitoringReport",
    RecyclingReport = "murn:smart:lookup/ReportType/RecyclingReport",
    SpillReport = "murn:smart:lookup/ReportType/SpillReport",
    VadoseZoneMonitoringReport = "murn:smart:lookup/ReportType/VadoseZoneMonitoringReport",
    WasteCharacterizationReport = "murn:smart:lookup/ReportType/WasteCharacterizationReport",
  }

  export enum ReportPeriods {
    Q = "murn:smart:lookup/ReportPeriod/Q",
    A = "murn:smart:lookup/ReportPeriod/A",
  }

  export enum State {
    AK = "murn:smart:lookup/State/AK",
    AL = "murn:smart:lookup/State/AL",
    AR = "murn:smart:lookup/State/AR",
    AS = "murn:smart:lookup/State/AS",
    AZ = "murn:smart:lookup/State/AZ",
    CA = "murn:smart:lookup/State/CA",
    CO = "murn:smart:lookup/State/CO",
    CT = "murn:smart:lookup/State/CT",
    DC = "murn:smart:lookup/State/DC",
    DE = "murn:smart:lookup/State/DE",
    FL = "murn:smart:lookup/State/FL",
    GA = "murn:smart:lookup/State/GA",
    GU = "murn:smart:lookup/State/GU",
    HI = "murn:smart:lookup/State/HI",
    IA = "murn:smart:lookup/State/IA",
    ID = "murn:smart:lookup/State/ID",
    IL = "murn:smart:lookup/State/IL",
    IN = "murn:smart:lookup/State/IN",
    KS = "murn:smart:lookup/State/KS",
    KY = "murn:smart:lookup/State/KY",
    LA = "murn:smart:lookup/State/LA",
    MA = "murn:smart:lookup/State/MA",
    MD = "murn:smart:lookup/State/MD",
    ME = "murn:smart:lookup/State/ME",
    MI = "murn:smart:lookup/State/MI",
    MN = "murn:smart:lookup/State/MN",
    MO = "murn:smart:lookup/State/MO",
    MP = "murn:smart:lookup/State/MP",
    MS = "murn:smart:lookup/State/MS",
    MT = "murn:smart:lookup/State/MT",
    NC = "murn:smart:lookup/State/NC",
    ND = "murn:smart:lookup/State/ND",
    NE = "murn:smart:lookup/State/NE",
    NH = "murn:smart:lookup/State/NH",
    NJ = "murn:smart:lookup/State/NJ",
    NM = "murn:smart:lookup/State/NM",
    NV = "murn:smart:lookup/State/NV",
    NY = "murn:smart:lookup/State/NY",
    OH = "murn:smart:lookup/State/OH",
    OK = "murn:smart:lookup/State/OK",
    OR = "murn:smart:lookup/State/OR",
    PA = "murn:smart:lookup/State/PA",
    PR = "murn:smart:lookup/State/PR",
    RI = "murn:smart:lookup/State/RI",
    SC = "murn:smart:lookup/State/SC",
    SD = "murn:smart:lookup/State/SD",
    TN = "murn:smart:lookup/State/TN",
    TX = "murn:smart:lookup/State/TX",
    UT = "murn:smart:lookup/State/UT",
    VT = "murn:smart:lookup/State/VT",
    VA = "murn:smart:lookup/State/VA",
    VI = "murn:smart:lookup/State/VI",
    WA = "murn:smart:lookup/State/WA",
    WI = "murn:smart:lookup/State/WI",
    WV = "murn:smart:lookup/State/WV",
    WY = "murn:smart:lookup/State/WY",
    AB = "murn:smart:lookup/State/AB",
    BC = "murn:smart:lookup/State/BC",
    MB = "murn:smart:lookup/State/MB",
    NB = "murn:smart:lookup/State/NB",
    NL = "murn:smart:lookup/State/NL",
    NS = "murn:smart:lookup/State/NS",
    ON = "murn:smart:lookup/State/ON",
    PE = "murn:smart:lookup/State/PE",
    QC = "murn:smart:lookup/State/QC",
    SK = "murn:smart:lookup/State/SK",
  }
}
